import { render, staticRenderFns } from "./InternalAgent.vue?vue&type=template&id=2db69604&scoped=true&"
import script from "./InternalAgent.vue?vue&type=script&lang=js&"
export * from "./InternalAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db69604",
  null
  
)

export default component.exports